var Seller = {
    openSession: 'mtop.im.use.web.seller.mtopimsessionviewservice.opensession',
    getSettings: 'mtop.im.use.web.seller.mtopImSettingService.getSettingsForSeller',
};
var Buyer = {
    openSession: 'mtop.im.use.web.buyer.mtopImSessionViewService.openSession',
    getSettings: 'mtop.im.use.web.buyer.mtopImSettingService.getSettingsForBuyer',
};
function getDefaultAPIMap(accountType) {
    return {
        timeStamp: 'mtop.common.getTimestamp',
        queryTreeInfo: "mtop.messagebox.web." + accountType + ".inboxview.queryTreeInfo",
        initNode: "mtop.im.use.web." + accountType + ".messagebox.querySessionList",
        queryNodeListBySessionId: "mtop.im.use." + accountType + ".messagebox.queryMessageListBySessionId",
        syncData: "mtop.taobao.wireless.lz." + accountType + ".js.sync",
        accsToken: "mtop.im.use.web." + accountType + ".mtopImTokenService.getToken",
        emoji: "mtop.im.use.web." + accountType + ".mtopImEmojiService.getAll",
        getLoginUserInfo: "mtop.im.use.web." + accountType + ".mtopImAccountService.getLoginUserInfo",
        getUserInfo: "mtop.im.use.web." + accountType + ".mtopImAccountService.getUserAccountInfo",
        getImgDownloadToken: "mtop.im.use.web." + accountType + ".mtopImMediaService.getDownloadToken",
        deleteSession: "mtop.im.receiver.web." + accountType + ".imSessionView.deleteSessionView",
        upImgToken: "mtop.im.use.web." + accountType + ".mtopImMediaService.getToken",
        sendMessage: "mtop.im.receiver.web." + accountType + ".imMessage.sendImMessage",
        putRangeReadOffset: "mtop.im.receiver.web." + accountType + ".usermessage.putRangeReadOffset",
        getShuntedState: "mtop.lazada.lsms.im.isshuntedtoothers.get",
        uploadImg: '',
        messageRecall: "mtop.im.receiver." + accountType + ".msg.recall",
    };
}
export function init(config) {
    var accountType = config.accountType === 1 ? 'buyer' : 'seller';
    var APIMap = getDefaultAPIMap(accountType);
    if (config.env === 'daily') {
        APIMap.uploadImg = 'http://media.daily.taobao.net/upload/upload.htm';
    }
    else if (config.env === 'pre') {
        APIMap.uploadImg = '//media.lazada.sg/upload/upload.htm';
    }
    else {
        var uploadImgDomain = config.region === 'id' ?
            'media.lazada.co.id' :
            'media.lazada.sg';
        APIMap.uploadImg = "https://" + uploadImgDomain + "/upload/upload.htm";
    }
    return Object.assign(APIMap, config.accountType === 1 ? Buyer : Seller, config.APIMap);
}
